var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PPage',{staticClass:"Cvs"},[_c('CvsContainer',{attrs:{"cvs":_vm.$store.getters['cvs/cvs'],"cover-letters":_vm.$store.getters['coverLetters/coverLetters']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }